export const STUDENT_ENDPOINT = {
  GetStudentSummary:
    'internal/students/Students/{studentId}/Schools/{schoolId}/Summary',
  GetNonSchoolDays:
    'internal/students/Students/{studentId}/Schools/{schoolId}/NonSchoolDays',
  GetSchoolHistoryForBase:
    'internal/students/Students/{studentId}/Schools/{schoolId}/SchoolHistory'
};
